import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import get from 'lodash/get'
import { create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  getters: {
    approvalUrl: (state) => get(state, ['item', 'approvalUrl'], null)
  },

  mutations: {
    paypalBillingAgreementFetched(state, { paypalBillingAgreement }) {
      state.item = paypalBillingAgreement
    },

    resetState(state) {
      state.item = null
    }
  },

  actions: {
    async createPaypalBillingAgreement({ commit }, { email, sku, seats }) {
      try {
        const response = await create({
          url: '/api/account/paypal-billing-agreement',
          type: 'paypal-billing-agreement',
          data: {},
          meta: {
            email,
            sku,
            seats
          }
        })

        const paypalBillingAgreement = await deserialize(response.data)

        commit('paypalBillingAgreementFetched', { paypalBillingAgreement })

        return paypalBillingAgreement
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
